import {
  BookRevenue,
  CreateWithdrawForm,
  GetDetailResponse,
  GetListResponseRevenue,
  GetRevenueRequestParams,
} from "@app/types";
import HttpService from "@core/services/http/http.service";

class _WalletService {
  public getRevenue(requestParams?: GetRevenueRequestParams) {
    return HttpService.get<GetListResponseRevenue<BookRevenue>>(
      "/admin/api/v3/author-revenue",
      {
        queryParams: { ...requestParams },
      }
    );
  }

  public createWithdraw(body: CreateWithdrawForm) {
    return HttpService.post<GetDetailResponse<{ message: string }>>(
      "/admin/api/v3/author-revenue/payment",
      {
        body: { ...body },
      }
    );
  }
}

const WalletService = new _WalletService();

export default WalletService;
